import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {IProfile, schemaProfile} from '../../core/interface'
import {RootState} from '../../../../../../redux/store'
import {
  useEditUserProfileMutation,
  useGetUserProfileQuery,
} from '../../../../../../redux/api/services/profile'
import {useFormik} from 'formik'
import {CustomErrorAlert} from '../../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export const UserEditCard = () => {
  const infoState = useSelector((state: RootState) => state.info)

  const userProfileStatus = useGetUserProfileQuery({
    info: infoState,
  })
  const [editProfile, editProfileStatus] = useEditUserProfileMutation()

  const handleSubmit = (values: IProfile) => {
    editProfile({
      info: infoState,
      requestContent: {
        name: values.name,
        phoneNumber: values.contactPhoneNumber,
      },
    })
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      contactPhoneNumber: '',
    },
    validationSchema: schemaProfile,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    if (userProfileStatus.isSuccess) {
      formik.setFieldValue('name', userProfileStatus.data?.responseContent.name)
      formik.setFieldValue(
        'contactPhoneNumber',
        userProfileStatus.data?.responseContent.contactPhoneNumber
      )
    }
  }, [userProfileStatus.isSuccess])

  return (
    <>
      <div className='card mb-5 mb-xl-10 pt-5 pb-5'>
        <CustomErrorAlert
          error={editProfileStatus.error}
          show={editProfileStatus.isError}
          close={editProfileStatus.reset}
          className='mx-5'
        />
        <CustomErrorAlert
          error={userProfileStatus.error}
          show={userProfileStatus.isError}
          className='mx-5'
        />
        <form className='form row g-3 w-100 card-body' onSubmit={formik.handleSubmit}>
          <div className='col-12 mb-5'>
            <label className='form-label mb-3 text-gray fs-2'>Nombre</label>
            <input
              name='name'
              type='text'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>{formik.errors.name}</div>
              </div>
            )}
          </div>
          <div className='col-12 mb-4'>
            <label className='form-label mb-3 text-gray fs-2'>Teléfono</label>
            <input
              name='contactPhoneNumber'
              type='text'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.contactPhoneNumber}
              onChange={formik.handleChange}
            />
            {formik.touched.contactPhoneNumber && formik.errors.contactPhoneNumber && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>{formik.errors.contactPhoneNumber}</div>
              </div>
            )}
          </div>
          <div className='col-12 mb-5'>
            <label className='form-label mb-3 text-gray fs-2'>Correo electrónico</label>
            <input
              name='email'
              type='email'
              className='form-control form-control-lg form-control-solid text-gray fs-2'
              value={userProfileStatus.data?.responseContent.emailAddress || ''}
              disabled
            />
          </div>

          <div className='col-12 mb-5'>
            <label className='form-label mb-3 text-gray fs-2'>Rol</label>
            <input
              name='role'
              type='text'
              className='form-control form-control-lg form-control-solid text-gray fs-2'
              value={userProfileStatus.data?.responseContent.formattedType || ''}
              disabled
            />
          </div>

          <div className='row g-3 mt-8 mb-3'>
            <div className='col d-flex justify-content-end'>
              <button
                className={'btn btn-primary ps-12 pe-10 rounded-pill fs-2'}
                type='submit'
                disabled={editProfileStatus.isLoading}
              >
                {!editProfileStatus.isLoading ? 'Guardar' : 'Cargando'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
